module.exports = __webpack_public_path__ + "img/candy-cane.6d5008f9.svg";